import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const MinutesSentConfirmation = () => {
  const navigate = useNavigate();

  return (
    <div className="minutes-sent-container">
      <div className="minutes-sent-card">
        <div className="minutes-sent-icon">
          <CheckCircle size={64} color="#22c55e" />
        </div>
        
        <h1 className="minutes-sent-title">Minutes Sent Successfully</h1>
        
        <p className="minutes-sent-message">
          Corrective actions (if any) sent and committee members notified.
        </p>
        
        <div className="minutes-sent-details">
          <p>The following actions have been completed:</p>
          <ul>
            <li>Meeting minutes have been finalized</li>
            <li>Committee members have been notified via email</li>
            <li>Corrective actions have been assigned and sent to responsible parties</li>
            <li>A PDF copy of the minutes has been generated and stored</li>
          </ul>
        </div>
        
        <button 
          className="btn-primary minutes-sent-button"
          onClick={() => navigate('/home')}
        >
          <ArrowLeft className="btn-icon" />
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default MinutesSentConfirmation;
